import IDEE from 'utils/Mapea';
import Utils from 'utils/Utils';
import LocalStorage from 'utils/LocalStorage';

import MAPA from 'static/img/mapa.png';
import IMAGEN from 'static/img/image.png';
import RASTER from 'static/img/raster.png';
import OPENSTREETMAP from 'static/img/openstreetmap.png';
import MARINE from 'static/img/marinegeo.png';

declare var ol;
declare var PRECHARGED;
declare var CONFIGURATIONS;
declare var SERVICIOS;

export let mapjs;

//**** funcion Get Url Parameter
function gup(name){
  var regexS = "[\\?&]"+name+"=([^&#]*)";
  var regex = new RegExp ( regexS );
  var tmpURL = window.location.href;
  var results = regex.exec( tmpURL );
  if( results == null )
    return "";
  else
    return results[1];
};

export const initMap = (unblock, t, params) => {
  const dpi = CONFIGURATIONS.scale_units.dots_per_inch;
  if (IDEE.config && typeof dpi === 'number') {
    IDEE.config.DPI = dpi;
  }
  const lang = LocalStorage.getString('language') || 'es';
  IDEE.language.setLang(lang);
  let zoom = 1;
  let center = [-734708.63923561, 4355801.2649719];
  let mouseProjection = CONFIGURATIONS.map.mouseProjection;
  let mapProjection = CONFIGURATIONS.map.mapProjection;
  
  // eslint-disable-next-line
  let filter = undefined;
  let userMaxExtent = CONFIGURATIONS.map.userMaxExtent;
  try {
    const arrayParams = params.split('&');
    arrayParams.forEach((param) => {
      if (param.indexOf('center') > -1) {
        const values = param.split('=')[1].split(',');
        center = [parseFloat(values[0]), parseFloat(values[1])];
      } else if (param.indexOf('zoom') > -1) {
        const value = param.split('=')[1];
        zoom = parseInt(value, 10);
      } else if (param.indexOf('srs') > -1) {
        const value = param.split('=')[1];
        mouseProjection = value;
      } else if (param.indexOf('filter') > -1) {
        const value = param.split('=')[1];
        filter = Utils.normalize(value);
      }
    });

    if (center[0] !== -428106.86611520057 && center[1] !== 4334472.25393817) {
      center = ol.proj.transform(center, mouseProjection, mapProjection);
    }
  } catch (err) {}

  // IDEE.config.PROXY_URL = 'https://ideihm.covam.es/ProxyRedirect/proxy';
  // IDEE.config.PROXY_POST_URL = 'https://ideihm.covam.es/ProxyRedirect/proxy';
  IDEE.proxy(false);

  if (Utils.isMobile()) {
    mapjs = IDEE.map({
      container: 'map',
      projection: mapProjection.concat('*m'),
      userMaxExtent: userMaxExtent,
      // controls: ['scale*true*24', 'panzoom', 'panzoombar', 'location', 'rotate', 'scaleline'],
      controls: ['scale*true', 'location', 'rotate', 'scaleline'],
      center: center,
      zoom: zoom,
      minZoom:0,
      maxZoom: 23,
    });

    window.mapjs = mapjs;
    mapjs.addPlugin(new IDEE.plugin.BackImgLayer(getConfiguredBaseLayersPlugin(t, true)));

    const backImgElem = document.querySelector('#map > div > div.ol-overlaycontainer-stopevent > div > div.m-area.m-bottom.m-right > div.m-panel.m-plugin-backimglayer.collapsed');
    backImgElem.position = 'fixed';
    backImgElem.bottom = '60px';
  } else {
    mapjs = IDEE.map({
      container: 'map',
      projection: mapProjection.concat('*m'),
      userMaxExtent: userMaxExtent,
      // controls: ['scale*true', 'panzoom', 'panzoombar', 'location', 'rotate', 'scaleline'],
      controls: ['scale*true', 'location', 'rotate', 'scaleline'],
      center: center,
      zoom: zoom,
      minZoom: 0,
      maxZoom: 23,
    });
    window.mapjs = mapjs;
    mapjs.addPlugin(new IDEE.plugin.BackImgLayer(getConfiguredBaseLayersPlugin(t, false)));
  }

  mapjs.getMapImpl().on('postrender', () => {
    const mapImpl = mapjs.getMapImpl();
    const spinner = document.getElementById('map-spinner');
    if (!spinner) return;

    const mapLoading = typeof mapImpl.getLoading === 'function' ? mapImpl.getLoading() : false;
    const tilesLoading = typeof mapImpl.tileQueue_?.getTilesLoading === 'function'
      ? mapImpl.tileQueue_.getTilesLoading() > 0
      : false;

    spinner.style.display = mapLoading || tilesLoading ? 'block' : 'none';
  });

  mapjs.getMapImpl().on('rendercomplete', () => {
    const spinner = document.getElementById('map-spinner');
    if (spinner) spinner.style.display = 'none';
  });
  
  const pmodal = new IDEE.plugin.Modal({
    position: CONFIGURATIONS.helpmodal.position,
    url_es: CONFIGURATIONS.helpmodal.url_es,
    url_en: CONFIGURATIONS.helpmodal.url_en,
  });
  mapjs.addPlugin(pmodal); 
    
  const now = new Date();
  const theYear = now.getFullYear();

  const simpleAttr = new IDEE.plugin.SimpleAttributions({
    scale: 10000,
    position: 'BL',
    label: `&copy; Instituto Hidrográfico de la Marina, ${theYear}`
  });

  mapjs.addPlugin(simpleAttr);
  
  mapjs.addPlugin(new IDEE.plugin.FullTOC({
    collapsed: true,
    position: 'TR',
    https: true,
    http: true,
    codsi: false,
    precharged: PRECHARGED,
  }));

  // Inclusión de capas en el mapa
  // Servicios desde servicios.js
  let layerlist
  SERVICIOS.forEach((servicio) => {
    if (servicio.type === 'WMS') {
      layerlist = new IDEE.layer.WMS({
        url: servicio.url,
        name: servicio.name,
        legend: servicio.legend,
        transparent: true,
        version: servicio.version,
        useCapabilities: servicio.useCapabilities,
        tiled: servicio.tiled
      }, {
        group: servicio.group
      });
    } else {
      layerlist = new IDEE.layer.WMTS({
        url: servicio.url,
        name: servicio.name,
        legend: servicio.legend,
        matrixSet: servicio.matrixSet,
        transparent: true,
        format: 'image/jpeg',
        version: servicio.version,
        tiled: servicio.tiled
      }, {
        group: servicio.group
      });
    }
    layerlist.setVisible(servicio.visible);
    mapjs.addLayers([layerlist]);
  });

  mapjs.addPlugin(new IDEE.plugin.GeometryDrawIhm({ position: 'TR' }));
  mapjs.addPlugin(new IDEE.plugin.Information({ position: 'TR' }));
  
  mapjs.addPlugin(new IDEE.plugin.ViewManagement({
    position: 'TL',
    predefinedZoom: [{
      name: t('visor.extend'),
      bbox: [-2392173.2372, 2200000.0, 1966571.8637, 6000000.0],
    }]}));
  
  mapjs.addPlugin(new IDEE.plugin.MeasureBarihm({ position: 'TR' }));
  
  mapjs.addPlugin(new IDEE.plugin.Zoomcarta({
    position: 'TL',
    files: CONFIGURATIONS.zoomcarta.files
  }));

  if (gup('wms') !== "") {
    const wms = gup('wms');
    const wmssplit = wms.split('/');
    PRECHARGED.groups = [{
      name: wmssplit[wmssplit.length - 1],
      services: [
        {
          name: wmssplit[wmssplit.length - 1],
          type: 'WMS',
          url: wms,
        },
      ],
    }]
  }

  mapjs.addPlugin(new IDEE.plugin.OverviewMap({
    position: 'BR',
    fixed: false,
    // zoom: 4,
    baseLayer: 'WMTS*https://www.ign.es/wmts/mapa-raster?*MTN*GoogleMapsCompatible*Cartografía del IGN*false*image/png*false*false*true',
    collapsed: true,
    collapsible: true,
  }));

  mapjs.addPlugin(new IDEE.plugin.IGNSearchihm({
    servicesToSearch: 'gn',
    maxResults: 300,
    noProcess: 'poblacion',
    countryCode: 'es',
    isCollapsed: false,
    collapsible: false,
    position: 'TR',
    reverse: true,
    searchPosition: 'geocoder,nomenclator',
    resultVisibility: false,
    urlToponimos: CONFIGURATIONS.ignsearchihm.urlToponimos,
    urlCandidates: 'https://www.cartociudad.es/geocoder/api/geocoder/candidatesJsonp',
    urlFind: 'https://www.cartociudad.es/geocoder/api/geocoder/findJsonp',
    urlReverse: 'https://www.cartociudad.es/geocoder/api/geocoder/reverseGeocode',
  }));

  mapjs.addPlugin(new IDEE.plugin.MouseSRS({
    position: 'BL',
    tooltip: t('visor.coordinates'),
    srs: mouseProjection,
    label: mouseProjection,
    precision: 4,
    geoDecimalDigits: 6,
    utmDecimalDigits: 2,
    activeZ: false,
    resolution: [{ resolution: '40M', zoom: 0 }, { resolution: '20M', zoom: 1 }, { resolution: '10M', zoom: 2 },
      { resolution: '5M', zoom: 3 }, { resolution: '3M', zoom: 4 }, { resolution: '1500K', zoom: 5 },
      { resolution: '1000K', zoom: 6 }, { resolution: '700K', zoom: 7 }, { resolution: '500K', zoom: 8 },
      { resolution: '350K', zoom: 9 }, { resolution: '260K', zoom: 10 }, { resolution: '180K', zoom: 11 },
      { resolution: '120K', zoom: 12 }, { resolution: '90K', zoom: 13 }, { resolution: '60K', zoom: 14 },
      { resolution: '45K', zoom: 15 }, { resolution: '30K', zoom: 16 }, { resolution: '22K', zoom: 17 },
      { resolution: '18K', zoom: 18 }, { resolution: '12K', zoom: 19 }, { resolution: '8000', zoom: 20 },
      { resolution: '4000', zoom: 21 }, { resolution: '2000', zoom: 22 }, { resolution: '1000', zoom: 23 }
    ],
    resolutionSelected: 1,
  }));

  mapjs.addPlugin(new IDEE.plugin.Maritimesignals({
    position: 'TL',
    url: CONFIGURATIONS.maritimesignals.url,
    searchFields: CONFIGURATIONS.maritimesignals.searchFields,
    urlImages: CONFIGURATIONS.maritimesignals.urlImages,
    extensionImages: CONFIGURATIONS.maritimesignals.extensionImages,
    nameDefaultImage: CONFIGURATIONS.maritimesignals.nameDefaultImage,
    codesImages: CONFIGURATIONS.maritimesignals.codesImages,
    codesStatus: CONFIGURATIONS.maritimesignals.codesStatus,
    codesNie: CONFIGURATIONS.maritimesignals.codesNie,
    leftCodes: CONFIGURATIONS.maritimesignals.leftCodes,
    warning: CONFIGURATIONS.maritimesignals.warning,
  }));

  mapjs.addPlugin(new IDEE.plugin.PrinterMapihm({
    position: CONFIGURATIONS.printermapihm.position,
    collapsed: CONFIGURATIONS.printermapihm.collapsed,
    collapsible: CONFIGURATIONS.printermapihm.collapsible,
    credits: CONFIGURATIONS.printermapihm.credits,
    serverUrl: CONFIGURATIONS.printermapihm.serverUrl,
    mapProxyUrl: CONFIGURATIONS.printermapihm.mapProxyUrl,
    ENCurl: CONFIGURATIONS.printermapihm.ENCurl,
    ENCLayer: CONFIGURATIONS.printermapihm.ENCLayer,
    printTemplate: CONFIGURATIONS.printermapihm.printTemplate,
    gridStyle: CONFIGURATIONS.printermapihm.gridStyle,
  }));

  mapjs.getMapImpl().once('postrender', (event) => {
    
    const inches_per_unit = CONFIGURATIONS.scale_units.inches_per_unit;
    // const inches_per_unit = 39.3701;
    const dots_per_inch = CONFIGURATIONS.scale_units.dots_per_inch;
    // const dots_per_inch = 72;

    // mapjs.getMapImpl().getView().setProjection('EPSG:3395');

    mapjs.getMapImpl().getView().setResolutions([
      40000000 / inches_per_unit / dots_per_inch,
      20000000 / inches_per_unit / dots_per_inch,
      10000000 / inches_per_unit / dots_per_inch,
      5000000 / inches_per_unit / dots_per_inch,
      3000000 / inches_per_unit / dots_per_inch,
      1500000 / inches_per_unit / dots_per_inch,
      1000000 / inches_per_unit / dots_per_inch,
      700000 / inches_per_unit / dots_per_inch,
      500000 / inches_per_unit / dots_per_inch,
      350000 / inches_per_unit / dots_per_inch,
      260000 / inches_per_unit / dots_per_inch,
      180000 / inches_per_unit / dots_per_inch,
      120000 / inches_per_unit / dots_per_inch,
      90000 / inches_per_unit / dots_per_inch,
      60000 / inches_per_unit / dots_per_inch,
      45000 / inches_per_unit / dots_per_inch,
      30000 / inches_per_unit / dots_per_inch,
      22000 / inches_per_unit / dots_per_inch,
      18000 / inches_per_unit / dots_per_inch,
      12000 / inches_per_unit / dots_per_inch,
      8000 / inches_per_unit / dots_per_inch,
      4000 / inches_per_unit / dots_per_inch,
      2000 / inches_per_unit / dots_per_inch,
      1000 / inches_per_unit / dots_per_inch
    ]);

    mapjs.setZoom(1);
  });


  if (gup('wms') !== "") {
    mapjs.getMapImpl().once('postrender', (evt) => {
      setTimeout(function(){document.querySelector(".m-plugin-fulltoc .m-fulltoc-addservice").click()},500);
    });
  }

  mapjs.getMapImpl().once('postrender', (evt) => {
    IDEE.proxy(CONFIGURATIONS.activaproxy.proxy);
    unblock();
  });

  mapjs.getMapImpl().getLayers().on("propertychange", function(e) {
    const layerslist = mapjs.getLayers();
    layerslist.forEach((layer) => {
      if (layer.name === 'Signals') {
        if (layer.getZIndex() !== 1038) layer.setZIndex(1038);
      } else if (layer.name === 'ExtentLayer') {
        if (layer.getZIndex() !== 1039) layer.setZIndex(1039);
      } else if (layer.name === 'copia') {
        if (layer.getZIndex() !== 1040) layer.setZIndex(1040);
      } else if (layer.name === 'selectLayer') {
        if (layer.getZIndex() !== 1041) layer.setZIndex(1041);
      } else if (layer.name === 'empty_layer') {
        if (layer.getZIndex() !== 1042) layer.setZIndex(1042);
      } else if (layer.name === '__draw__') {
        if (layer.getZIndex() !== 1043) layer.setZIndex(1043);
      }
    });
  });
};

const getConfiguredBaseLayersPlugin = (t, isMobile) => {
  return {
    position: isMobile ? 'BR' : 'TR',
    layerId: 0,
    layerVisibility: true,
    collapsed: true,
    collapsible: true,
    columnsNumber: 3,
    empty: false,
    layerOpts: [{
        id: 'mapa',
        preview: MAPA,
        title: t('visor.street_map'),
        layers: [
          new IDEE.layer.WMTS({
            url: 'https://www.ign.es/wmts/ign-base?',
            name: 'IGNBaseTodo',
            legend: t('visor.street_map'),
            matrixSet: 'GoogleMapsCompatible',
            isBase: true,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
        ],
      },
      {
        id: 'raster',
        preview: RASTER,
        title: t('visor.map'),
        layers: [
          new IDEE.layer.WMTS({
            url: 'https://www.ign.es/wmts/mapa-raster?',
            name: 'MTN',
            legend: t('visor.map'),
            matrixSet: 'GoogleMapsCompatible',
            isBase: true,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
        ],
      },
      {
        id: 'imagen',
        preview: IMAGEN,
        title: t('visor.image'),
        layers: [
          new IDEE.layer.WMTS({
            url: 'https://www.ign.es/wmts/pnoa-ma?',
            name: 'OI.OrthoimageCoverage',
            legend: t('visor.image'),
            matrixSet: 'GoogleMapsCompatible',
            isBase: true,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
        ],
      },
      {
        id: 'OpenStreetMap',
        preview: OPENSTREETMAP,
        title: 'OpenStreetMap',
        layers: [
          new IDEE.layer.OSM({
            name: 'OSM',
            legend: 'OSM',
            isBase: true,
            tiled: true,
            url: 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
            matrixSet: 'EPSG:3857',
            visible: true,
          },{displayInLayerSwitcher: false}),
        ],
      },
      {
        id: 'MarineGeo',
        preview: MARINE,
        title: t('visor.marine'),
        layers: [
          new IDEE.layer.WMS({
            url: 'https://www.gmrt.org/services/mapserver/wms_merc?',
            name: 'topo',
            legend: t('visor.marine'),
            isBase: true,
            useCapabilities: false,
          })
        ],
      },
      {
        id: 'hibrido',
        title: 'Híbrido',
        preview: IMAGEN,
        layers: [new IDEE.layer.WMTS({
            url: 'https://www.ign.es/wmts/pnoa-ma?',
            name: 'OI.OrthoimageCoverage',
            legend: 'Imagen (PNOA)',
            matrixSet: 'GoogleMapsCompatible',
            isBase: true,
            queryable: false,
            visible: true,
            format: 'image/png',
          }),
          new IDEE.layer.WMTS({
            url: 'https://www.ign.es/wmts/ign-base?',
            name: 'IGNBaseOrto',
            matrixSet: 'GoogleMapsCompatible',
            legend: 'Mapa IGN',
            isBase: false,
            queryable: false,
            visible: true,
            format: 'image/png',
          },{displayInLayerSwitcher: false})
        ],
      },
    ],
  };
}
